import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import DrivingLicenceV2OutputComponent from '../output/DrivingLicenceV2OutputComponent';

const DrivingLicenceV2InputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-car', title: 'Driving Licence Verification (v2)', subtitle: 'Enhanced DL verification via Gridlines' }}
        fields={[
            { name: 'driving_license_number', label: 'DL Number', icon: 'pi-id-card', placeholder: 'MH01-20100000000', maxLength: 20, autoCapitalize: 'characters', spellCheck: false, uppercase: true, mono: true },
            { name: 'date_of_birth', label: 'Date of Birth', icon: 'pi-calendar', placeholder: 'YYYY-MM-DD', maxLength: 10, mono: true,
              regex: /^\d{4}-\d{2}-\d{2}$/, regexError: 'Format: YYYY-MM-DD' },
        ]}
        endpoint={{
            path: '/gridlines/dl-details',
            bodyMapper: (v, sid) => ({
                driving_license_number: v.driving_license_number,
                date_of_birth: v.date_of_birth,
                consent: 'Y',
                api_provider_service_id: parseInt(sid, 10),
            }),
        }}
        consentReportType="driving-licence"
        submitLabel="Verify Driving Licence"
        successSummary="Driving licence verified"
        errorSummary="Driving licence verification failed"
        confirmHeader="Confirm driving licence verification"
        confirmAcceptLabel="Yes, verify"
        outputComponent={DrivingLicenceV2OutputComponent}
        // Downloads over the authenticated axios instance. The old path handed
        // the browser a `?token=…` public URL whose token lives in the cache —
        // it 401s the moment that entry is gone (and always, when the cache
        // driver is `array`). This one carries the Bearer token instead.
        pdfEndpoint={(reportId) => `/gridlines/dl-v2/${reportId}/download-pdf`}
        pdfPasswordHint='PDF is password protected — use the last 6 characters of the DL number + "DL" (e.g. 123456DL).'
    />
);

export default DrivingLicenceV2InputComponent;
